import React from "react";
// import { RouteComponentProps, withRouter } from "react-router-dom";
import Admin from "us.collection.admin";
import { withRouter } from "us.common/wIthRouter";

// interface ICntManageFollowup extends RouteComponentProps {}
interface ICntManageFollowup  {}
const Cnt_ManageFollowup: React.FC<ICntManageFollowup> = (props) => {
  return (
    <>
      <Admin.Components.ManageFollowup.Home />
    </>
  );
};

export default withRouter(Cnt_ManageFollowup);
